import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { NgUtils } from 'tiime-expert-utils';
import type { TooltipPosition } from 'tiime-material';

@Component({
  selector: 'app-tag-list-icon',
  templateUrl: './tag-list-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TagListIconComponent {
  @Input() tags: string[] = [];
  @Input() tooltipPosition: TooltipPosition = 'bottom';

  readonly trackByIndex = NgUtils.trackByIndex;
}
